import React, { useState, useEffect, useContext } from "react";
import ReactLoading from "react-loading";
import { DataGrid } from "@material-ui/data-grid";
import { useHistory } from "react-router-dom";

import api from "../../services/api";
import { notify } from "../../utils/notify";
import { ReportAccountantContext } from "../../context/ReportAccountantContext";
import { UserContext } from "../../context/UserContext";
import { GlobalVariables } from "../../global";
import MaskService from "../../utils/mask/maskService";
import "./reportAccountant.css";
import CheckIcon from "@material-ui/icons/Check";

const renderCell = (props) => {
  if (props.value === "processando")
    return (
      <div style={{ paddingTop: 10 }}>
        <ReactLoading width="1.7rem" type="spinningBubbles" color="gray" />
      </div>
    );

  if (props.value) return <CheckIcon style={{ color: "green" }} />;

  return <></>;
};

const columns = [
  { field: "CNPJ", headerName: "CNPJ", width: 161 },
  { field: "Razao", headerName: "Razão", width: 220 },
  {
    field: "NFeSaida",
    headerName: "NFe Saída",
    width: 101,
    renderCell,
    align: "center",
  },
  {
    field: "NFeEntrada",
    headerName: "NFe Entrada",
    width: 114,
    renderCell,
    align: "center",
  },
  {
    field: "ArqContabil",
    headerName: "Arq. Contábil",
    width: 115,
    renderCell,
    align: "center",
  },
  {
    field: "MotivoCancelamento",
    headerName: "Status",
    width: 100,
  },
  { field: "Rota", headerName: "Nome de Acesso", width: 160 },
];

export default function DataTable() {
  const {
    cnpj,
    base,
    setValuesTable,
    reason,
    status,
    accountant,
    mounth,
    year,
    selectionClients,
    setSelectionClients,
  } = useContext(ReportAccountantContext);
  const { user } = useContext(UserContext);
  const { push } = useHistory();
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [rowsFilter, setRowsFilter] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let error = false;

        if (!mounth || !mounth.id) {
          notify("Selecione o mês.");
          error = true;
        }

        if (!year || !year.descricao) {
          notify("Selecione o ano.");
          error = true;
        }

        if (error) return setLoading(false);

        setRowsFilter([]);

        let route = `relatorio/contador/${mounth.id}/${year.descricao}/${user.PromotorCNPJ}`;

        if (user.IdTipoUsuario === GlobalVariables.ADM_QYON) {
          route = `relatorio/contador/${mounth.id}/${year.descricao}`;
        } else if (
          GlobalVariables.TIPO_PROMOTOR_CONTADOR !== user.IdTipoPromotor
        ) {
          push("/homePage");
          return notify("Este relatório é apenas para usuários contabilistas.");
        }

        const { data: response } = await api.get(route);

        response.data.forEach((employee) => {
          employee.id = employee.ClienteCNPJ;
          employee.CNPJ = MaskService.toMask("cnpj", employee.ClienteCNPJ);
        });

        setValuesTable(response.data);
        setRowsFilter(response.data);
        setAllRows(response.data);
        setLoading(false);
      } catch (error) {
        console.error("ERROR: PreviewReportAccountant fechData", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [setValuesTable, user, push, year, mounth]);

  useEffect(() => {
    try {
      setLoadingFilter(true);

      const newRowsFilter = [...allRows].filter((element) => {
        return (
          (!cnpj ||
            element.ClienteCNPJ.toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[^a-z0-9]/gi, "")
              .indexOf(
                cnpj
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[^a-z0-9]/gi, "")
              ) !== -1) &&
          (!reason ||
            element.Razao.toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[^a-z0-9]/gi, "")
              .indexOf(
                reason
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[^a-z0-9]/gi, "")
              ) !== -1) &&
          (!base ||
            element.Rota.toString()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[^a-z0-9]/gi, "")
              .indexOf(
                base
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[^a-z0-9]/gi, "")
              ) !== -1) &&
          (!status || element.IdMotivoCancelamento === status.Id) &&
          (!accountant || element.ContadorCNPJ === accountant.CNPJ)
        );
      });

      setRowsFilter(newRowsFilter);
      setLoadingFilter(false);
    } catch (error) {
      console.error("ERROR DataTableAccountant filter:", error);
      setLoadingFilter(false);
    }
  }, [cnpj, reason, status, accountant, base, allRows]);

  return (
    <div className="contaier-data-table">
      <DataGrid
        autoHeight
        disableColumnMenu
        loading={loading || loadingFilter}
        rows={rowsFilter}
        columns={columns}
        pageSize={5}
        checkboxSelection
        onSelectionModelChange={(newSelection) => {
          setSelectionClients(newSelection.selectionModel);
        }}
        selectionModel={selectionClients}
      />
    </div>
  );
}
